/* Sami Jewels Loop On-Store bootstrap, 2026-09-28-v1.
 * Supported vendor SDK only. No test key, policy writes or automatic test mode.
 * Ordinary shoppers are not in an active Loop session.
 */
(function () {
  'use strict';
  if (window.SamiLoopOnstore) return;

  var state = { status: 'starting', version: '2026-09-28-v1' };
  window.SamiLoopOnstore = state;

  function fail(code) {
    state.status = code;
    console.error('Sami Jewels Loop setup:', code);
  }

  function boot() {
    var configNode = document.getElementById('sami-loop-onstore-config');
    if (!configNode) {
      state.status = 'not-configured';
      return;
    }

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      fail('invalid-configuration');
      return;
    }

    // Never let the vendor SDK reuse a stale cached key when this one is blank.
    if (typeof config.key !== 'string' || !config.key.trim()) {
      state.status = 'waiting-for-cart-only-key';
      return;
    }
    if (typeof config.attach !== 'string' || !config.attach.trim()) {
      fail('missing-checkout-selectors');
      return;
    }
    try {
      document.querySelectorAll(config.attach);
    } catch (error) {
      fail('invalid-checkout-selectors');
      return;
    }
    if (!window.LoopOnstore || typeof window.LoopOnstore.init !== 'function') {
      fail('vendor-sdk-unavailable');
      return;
    }

    var resizeObserver;
    function measureBanner() {
      var banner = document.getElementById('loop-onstore');
      if (!banner || !document.body.classList.contains('loop-returns-activated')) return;
      var height = Math.ceil(banner.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty('--sj-loop-bar-height', height + 'px');
      }
      if (!resizeObserver && typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(function () {
          var measured = Math.ceil(banner.getBoundingClientRect().height);
          if (measured > 0) {
            document.documentElement.style.setProperty('--sj-loop-bar-height', measured + 'px');
          }
        });
        resizeObserver.observe(banner);
      }
    }

    document.addEventListener('Loop:Activated', function () {
      state.status = 'active-session';
      measureBanner();
    });
    document.addEventListener('Loop:Back To Loop', function () {
      state.status = 'returning-to-loop';
    });

    // init owns dynamic checkout reattachment through the vendor's observer.
    // Do not install a second click interceptor or re-initialize the SDK.
    state.status = 'initializing';
    try {
      Promise.resolve(window.LoopOnstore.init({
        key: config.key.trim(),
        attach: config.attach.trim(),
        full: config.full === true
      })).then(function () {
        state.status = window.LoopOnstore.isActive() ? 'active-session' : 'ordinary-shopping';
        measureBanner();
      }).catch(function () {
        fail('vendor-initialization-failed');
      });
    } catch (error) {
      fail('vendor-initialization-failed');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());
